import { CircularProgress, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import Entrega from "./Entregas/Entrega"
import { useAppTheme } from "../../../../Providers/ThemeContext/ThemeContext"
import { useContext } from "react"
import { EncomendaContex } from "../../../../Providers/EncomendaContext/EncomendaContext"

const ListaEntregas = () => {
    const { theme } = useAppTheme()
    const { resultEntregas, loading } = useContext(EncomendaContex)

    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflowY: 'auto', marginTop: '5px' }}>
                {
                    loading
                        ? <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress size={50} sx={{ color: theme.palette.one_primary.main }} />
                        </Grid>
                        : (
                            resultEntregas.length > 0
                                ? resultEntregas.map((dado, index) => (
                                    <Entrega key={index} index={index} entrega={dado} ></Entrega>
                                ))
                                : (
                                    <Typography>Nenhum dado encontrado</Typography>
                                )
                        )
                }
            </Grid>

        </Grid>
    )
}
export default ListaEntregas
